<template>
    <div>
        <reservation-digital-signature-icon
            @sign-click="showModal"
            :reservation="reservation"
        />
        <reservation-travel-insurance-icon
            v-if="reservation.has_travel_insurance"
        />
        <digital-signature-request-modal
            :modalId="modalId"
            :initialValues="reservation"
            :onUpdate="onUpdate"
        />
    </div>
</template>

<script>
import DigitalSignatureRequestModal from '../../../common/digital-signature-request-modal.vue';
import ReservationDigitalSignatureIcon from '../../../common/reservation-digital-signature-icon.vue';
import ReservationTravelInsuranceIcon from '../../../common/reservation-travel-insurance-icon.vue';

export default {
    components: {
        DigitalSignatureRequestModal,
        ReservationDigitalSignatureIcon,
        ReservationTravelInsuranceIcon,
    },
    data() {
        return {
            reservation: {},
        };
    },
    created() {
        this.reservation = this.params.data;
    },
    computed: {
        modalId() {
            return `signature-reservations-modal-${this.reservation.id}-${(Math.random() * 1e16).toString(36)}`;
        },
    },
    methods: {
        showModal() {
            this.$bvModal.show(this.modalId);
        },
        onUpdate() {
            this.params?.update();
        },
    },
};
</script>